<dx-popup
  #editProfilePopup
  class="popup"
  minWidth="300px"
  width="367px"
  height="auto"
  [showTitle]="true"
  [title]="title"
  [dragEnabled]="true"
  [hideOnOutsideClick]="false"
  [(visible)]="popupVisible"
  (onShown)="repaint()"
>
  <div *dxTemplate="let data of 'content'">
    <dx-validation-group #validatorProfileImage>
      <dx-box
        class="cc-bordered-box responsive-paddings"
        direction="col"
        width="100%"
      >
        <dxi-item baseSize="auto">
          <dx-box direction="col" align="center" crossAlign="center">
            <dxi-item [ratio]="!isSmallScreen ? 1 : undefined" baseSize="auto">
              <i
                *ngIf="!userProfileImage?.imageBase64"
                class="fa-solid fa-user-circle fa-10x"
              ></i>
              <img
                *ngIf="!!userProfileImage?.imageBase64"
                [src]="userProfileImage?.imageBase64"
                class="cc-edit-profile-image"
              />
            </dxi-item>
            <dxi-item baseSize="10"></dxi-item>
            <dxi-item baseSize="auto">
              <dx-toolbar>
                <dxi-item
                  location="center"
                  widget="dxButton"
                  [options]="{
                    type: 'default',
                    icon: editButtonIcon,
                    text: 'Edit',
                    onClick: onProcessProfileImageClick
                  }"
                ></dxi-item>
                <dxi-item
                  *ngIf="!!userProfileImage?.imageBase64"
                  location="center"
                  widget="dxButton"
                  [options]="{
                    type: 'danger',
                    icon: cancelButtonIcon,
                    text: 'Remove',
                    onClick: onRemoveImageClick
                  }"
                ></dxi-item>
              </dx-toolbar>
            </dxi-item>
          </dx-box>
        </dxi-item>
        <dxi-item baseSize="auto">
          <dx-box
            direction="row"
            width="100%"
            class="cc-edit-profile-button-container"
            align="end"
            crossAlign="center"
          >
            <dxi-item [ratio]="1">
              <dx-button
                type="default"
                [width]="100"
                hint="Close this window"
                text="Cancel"
                [icon]="cancelButtonIcon"
                (onClick)="hide()"
              ></dx-button>
            </dxi-item>
            <dxi-item baseSize="auto">
              <dx-button
                type="success"
                [width]="100"
                text="Save"
                hint="Save Profile Image"
                [disabled]="!(profileImageEdited && profileImageRemoved)"
                (onClick)="onSaveClick()"
                [icon]="saveButtonIcon"
              ></dx-button>
            </dxi-item>
          </dx-box>
        </dxi-item>
      </dx-box>
    </dx-validation-group>
  </div>
</dx-popup>

<app-image-editor
  #profileImageEditor
  *ngIf="isSupportEditImage"
  title="Profile Image"
  [width]="isSmallScreen ? '85%' : 320"
  [height]="isSmallScreen ? (isLandscape ? '80%' : '60%') : 440"
  [allowDrag]="true"
  [allowResize]="true"
  [showCloseButton]="true"
  (imageEdited)="imageCropped($event)"
></app-image-editor>

<dx-load-panel
  #editProfileLoadingPanel
  [position]="{ of: '#profileInfoContainer' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>
